<template>

    <v-snackbar v-model="state" :color="type" :location="location" :timer="style.timerColor" :timeout="timeout"
        :transition="transition" close-on-content-click>

        <v-alert class="pa-0" :density="style.density" :type="type" color="transparent" :title="title" :text="text"
            :width="style.width">
            <p class="text-overline mt-3 mb-0" v-if="code">Code: {{ code }}</p>
        </v-alert>
    </v-snackbar>
</template>

<script>
export default {
    name: 'ToastAlert',
    data() {
        return {
            state: true,
            style: {
                width: 250,
                density: 'compact',
                timerColor: 'white',
            },
            timeout: 5000,
        }
    },
    props: {
        type: {
            type: String,
            default: 'info',
        },
        code: {
            type: [String, Number],
            default: null,
        },
        title: {
            type: String,
        },
        text: {
            type: String,
        },
    },
    computed: {
        location() {
            if (this.$vuetify.display.smAndDown) {
                return 'top';
            } else {
                return 'top right';
            }
        },
        transition() {
            if (this.$vuetify.display.smAndDown) {
                return 'slide-y-transition';
            } else {
                return 'slide-x-reverse-transition';
            }
        },
    },
};
</script>